import _ from "lodash";
import PageViewer from "@/components/PageViewer";
import PERMISSIONS from "@/common/permissions-lib";
import store from "@/store";

const dsrcProps = route => {
	return {
		deviceIdentifier: parseInt(route.params.rsuIdentifier),
		deviceType: "rsu"
	};
};

export default {
	path: "DSRC",
	props: dsrcProps,
	component: PageViewer,
	meta: {
		authorizedRoles: [PERMISSIONS.RSU_TIM_VIEW, PERMISSIONS.RSU_MAP_VIEW]
	},
	children: [
		{
			path: "/",
			name: "DeviceManager.RSU.DSRC",
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.DSRC" */ "@/views/DeviceManager/DSRC/Index"
				),
			props: dsrcProps
		},
		{
			path: "TIM",
			component: PageViewer,
			props: dsrcProps,
			meta: {
				breadcrumb: "TIMs",
				authorizedRoles: [PERMISSIONS.RSU_TIM_VIEW]
			},
			children: [
				{
					path: "/",
					name: "DeviceManager.RSU.DSRC.TIM",
					props: route => {
						return {
							...dsrcProps(route),
							pageTransition: "none"
						};
					},
					component: () =>
						import(
							/* webpackChunkName: "DeviceManager.RSU.DSRC.TIMIndex" */ "@/views/DeviceManager/DSRC/TIM/TIMList"
						)
				},
				{
					path: ":timIdentifier/:action?",
					name: "DeviceManager.RSU.DSRC.TIM.byIdentifier",
					beforeEnter: (to, from, next) => {
						// If there's no action, then no further checks required.
						if (!to.params.action) {
							next();
							return;
						}

						// Check only needed for edit or create actions.
						const action = to.params.action.toLowerCase();
						if (action === "edit" || action === "create") {
							if (store.getters.currentUserHasRole(PERMISSIONS.RSU_TIM_EDIT)) {
								next();
								return;
							}
							next("Unauthorized");
							return;
						}

						// Default
						next();
						return;
					},
					props: route => {
						route.params.action = route.params.action || "view";
						return {
							...dsrcProps(route),
							timIdentifier: parseInt(route.params.timIdentifier),
							action: route.params.action
						};
					},
					meta: {
						breadcrumb() {
							if (_.isNil(this.$route.params.action)) {
								return "View";
							}
							return (
								this.$route.params.action.charAt(0).toUpperCase() +
								this.$route.params.action.slice(1)
							);
						}
					},
					component: () =>
						import(
							/* webpackChunkName: "DeviceManager.RSU.DSRC.TIM" */ "@/views/DeviceManager/DSRC/TIM/TIMDetail"
						)
				}
			]
		},
		{
			path: "RWM",
			component: PageViewer,
			props: dsrcProps,
			meta: {
				breadcrumb: "RWMs",
				authorizedRoles: [PERMISSIONS.RSU_RWM_VIEW]
			},
			children: [
				{
					path: "/",
					name: "DeviceManager.RSU.DSRC.RWM",
					props: route => {
						return {
							...dsrcProps(route),
							pageTransition: "none"
						};
					},
					component: () => import("@/views/DeviceManager/DSRC/RWM/RWMList")
				},
				{
					path: ":rwmIdentifier/:action?",
					name: "DeviceManager.RSU.DSRC.RWM.byIdentifier",
					beforeEnter: (to, from, next) => {
						// If there's no action, then no further checks required.
						if (!to.params.action) {
							next();
							return;
						}

						// Check only needed for edit or create actions.
						const action = to.params.action.toLowerCase();
						if (action === "edit" || action === "create") {
							if (store.getters.currentUserHasRole(PERMISSIONS.RSU_RWM_EDIT)) {
								next();
								return;
							}
							next("Unauthorized");
							return;
						}

						// Default
						next();
						return;
					},
					props: route => {
						route.params.action = route.params.action || "view";
						return {
							...dsrcProps(route),
							rwmIdentifier: parseInt(route.params.rwmIdentifier),
							action: route.params.action
						};
					},
					meta: {
						breadcrumb() {
							if (_.isNil(this.$route.params.action)) {
								return "View";
							}
							return (
								this.$route.params.action.charAt(0).toUpperCase() +
								this.$route.params.action.slice(1)
							);
						}
					},
					component: () => import("@/views/DeviceManager/DSRC/RWM/RWMDetail")
				}
			]
		},
		{
			path: "MAP",
			props: dsrcProps,
			meta: {
				breadcrumb: "MAP",
				authorizedRoles: [PERMISSIONS.RSU_MAP_VIEW]
			},
			name: "DeviceManager.RSU.DSRC.MAP",
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.DSRC.MAP" */ "@/views/DeviceManager/DSRC/MAP/Index"
				)
		}
	]
};
